// Lightweight i18n (§20 cs/en). Strings are keyed by their English text; the active
// language is persisted in localStorage (a preference, not a secret). Missing Czech keys
// fall back to English so coverage can grow incrementally.
import { create } from "zustand";
import { cs } from "./cs";

export type Lang = "en" | "cs";

const KEY = "vault.lang";
function initial(): Lang {
  const v = (typeof localStorage !== "undefined" && localStorage.getItem(KEY)) as Lang | null;
  return v === "cs" || v === "en" ? v : "en";
}

interface I18nState {
  lang: Lang;
  setLang: (l: Lang) => void;
}

export const useI18n = create<I18nState>((set) => ({
  lang: initial(),
  setLang: (lang) => {
    try {
      localStorage.setItem(KEY, lang);
    } catch {
      /* ignore */
    }
    set({ lang });
  },
}));

/** Hook returning a translate function bound to the active language (re-renders on switch). */
export function useT(): (key: string) => string {
  const lang = useI18n((s) => s.lang);
  return (key: string) => (lang === "cs" ? (cs[key] ?? key) : key);
}
